<template>
  <div class="GoodsReturn">
    <div class="GoodsReturn_top">
      <el-form :model="info_data"
               ref="info_data"
               label-width="100px"
               class="demo-ruleForm">

        <el-form-item label="退款金额 : "
                      prop="moneyInfo"
                      :rules="[
      { required: true, message: '金额不能为空'},
      { type: 'number', message: '金额必须为数字值'}
    ]">
          <el-input type="age"
                    placeholder="如用户弃货金额为 0"
                    v-model.number="info_data.moneyInfo"
                    autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="退货收件人 : "
                      prop="nameInfo"
                      :rules="[
      { required: true, message: '收件人姓名不能为空'}
    ]">
          <el-input type="age"
                    placeholder="收件人姓名"
                    v-model="info_data.nameInfo"
                    autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="联系电话 : "
                      prop="mobileInfo"
                      :rules="[
      { required: true, message: '请输入退货人的联系电话'}
    ]">
          <el-input type="age"
                    placeholder="退货人的联系方式"
                    v-model="info_data.mobileInfo"
                    autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="退货国家 : "
                      prop="siteInfo"
                      :rules="[
      { required: true, message: '只能输入中/英文国家名'}
    ]">
          <el-input type="age"
                    placeholder="只能输入中/英文国家名"
                    v-model="info_data.siteInfo"
                    autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="详细地址 : "
                      prop="addressInfo"
                      :rules="[
      { required: true, message: '请输入退货人的详细退货地址'}
    ]">
          <el-input type="age"
                    placeholder="详细退货地址"
                    v-model="info_data.addressInfo"
                    autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="退货说明 : "
                      prop="remarkInfo"
                      :rules="[
      { required: true, message: '请输入退货说明'}
    ]">
          <el-input type="age"
                    placeholder="退货理由"
                    v-model="info_data.remarkInfo"
                    autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="恢复状态 : "
                      prop="hfstatus"
                      :rules="[
      { required: true, message: '请选择退货后来恢复的状态'}
    ]">
          <el-select v-model="info_data.hfstatus"
                     filterable
                     placeholder="请选择">
            <el-option v-for="(item,index) in orderParticulars.zttype"
                       :key="index"
                       :label="item"
                       :value="index">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="width: 110px;"
                      prop="ck"
                      :rules="[
      { required: true, message: '必选'}
    ]"
                      label="货是否在仓 :">
          <div class="slectel_btn">
            <el-radio v-model="info_data.ck"
                      label="1"
                      border>货物仍在仓</el-radio>
            <el-radio v-model="info_data.ck"
                      label="0"
                      border>货物已出仓</el-radio>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="GoodsReturn_main">
      <el-transfer filterable
                   :titles="['所有物品', '退货物品']"
                   filter-placeholder="请输入物品名"
                   :button-texts="[ '移除退货','添加退货']"
                   v-model="returnGoods"
                   :props="{
      key: 'id',
      label: 'name'
    }"
                   :data="allData">
      </el-transfer>
      <div class="GoodsReturn_main_btn">
        <el-button type="primary"
                   @click="submitForm('info_data')">确定退货</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Form } from 'element-ui'
import { apiOrderDetails, apiSalesReturn_1 } from '@/request/api.js'
export default {
  name: 'GoodsReturn',
  data () {
    return {
      info_data: {
        remarkInfo: '',
        moneyInfo: '',
        nameInfo: '',
        mobileInfo: '',
        siteInfo: '',
        addressInfo: '',
        hfstatus: '',
        ck: '1',
      },
      hfstatusData: '',
      orderParticulars: '',
      returnGoods: [],
      allData: []
    }
  },
  methods: {
    async getGoodsInfo () {
      let res = await apiOrderDetails({
        op: 'orderinfo',
        pd: 'getinfo',
        orderid: this.$route.query.id
      })
      console.log(res);
      this.orderParticulars = res
      let arr = []
      for (const k in res.xz_weight_tj) {
        for (const key in res.xz_weight_tj[k].wpinfo) {
          arr.push(res.xz_weight_tj[k].wpinfo[key])
        }
      }
      this.allData = arr

    },
    submitForm (formName) {  //数据检测
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.returnGoods[0]) {
            this.$confirm('是否确定退物品?此操作不可逆转!!', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.submitData()
            })
          }
          else {
            this.$message.error('您还没有选择退货物品呢')
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async submitData () {
      const loading = this.$loading({
        lock: true
      });
      let res = await apiSalesReturn_1({
        do: 'orderadmin',
        info: this.info_data.remarkInfo,
        tuiheprice: this.info_data.moneyInfo,
        orderid: this.orderParticulars.id,
        hfstatus: this.orderParticulars.status,
        wpid: this.returnGoods,
        sjname: this.info_data.nameInfo,
        gjid: this.info_data.siteInfo,
        sjmobile: this.info_data.mobileInfo,
        sjaddress: this.info_data.addressInfo,
        ck: this.info_data.ck,
      })
      if (res.errno == 0) {
        this.$confirm('退货详细提交成功,是否需要打印退货单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        })
          .then(() => {
            console.log(11);
            this.$router.push({
              name: 'Invoice',
              params: {
                tuiheinfo: res.tuiheinfo,
                type: 'returnGoods',
                thtype: res.thtype
              }
            })
          })
      }
      loading.close();
      console.log(res);
    }
  },
  created () {
    this.getGoodsInfo()
  }
}
</script>

<style lang='scss'>
.GoodsReturn {
  width: 100%;
  height: 100%;
  // background-color: rgba(255, 192, 203, 0.315);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .GoodsReturn_top {
    width: 100%;
    min-height: 200px;
    background-color: #fff;
    .el-form {
      display: flex;
      flex-wrap: wrap;
      .el-form-item {
        width: 20%;
        min-width: 250px;
        margin: 10px 0;
        margin-right: 2.5%;
        margin-left: 2.5%;
        .slectel_btn {
          width: 400px;
        }
      }
    }
  }
  .GoodsReturn_main {
    width: 100%;
    height: 80%;
    background-color: #fff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .GoodsReturn_main_btn {
      width: 90%;
      height: 100px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .el-transfer {
      width: 1000px;
      height: 500px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .el-transfer-panel {
        height: 100%;
        width: 30%;
      }
    }
  }
}
</style>